import React, { useEffect } from 'react';
import { useAuthState } from '@trp-ta-nitro/auth-react';
import PhoneNumber from '../../../components/PhoneNumber/PhoneNumber';
import ConfirmationHeading from '../../../components/ConfirmationSection/ConfirmationHeading';
import { MFBeaconButton } from '../../../components/Beacon/BeaconComponents';
import FundLaterTransactionConfirmationDetails from '../../../components/ConfirmationSection/v2/FundLaterTransactionConfirmationDetails';
import styles from '../styles.css';
import ExternalAuthenticator from '../../../components/BaseLayout/ExternalAuthenticator';
import { redirectToAccountAccess } from '../../../components/ConfirmationSection/v2/util';
import {
  navigateToTrustedContact,
  openMailACheckSlip,
  redirectToBuyFlow
} from './utils';

const BuySharesSection = ({ remittanceFormURL, isGuestTypeUser }) => {
  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3 className="confirmation-section-headers">
            Buy shares of your selected Investments
          </h3>
          <p>
            Buy shares electronically with a linked bank account or mail a check
            following the instructions provided.
          </p>
          <div className="next-steps-butns">
            <span className="next-steps-shares-btn">
              <MFBeaconButton
                data-e2e="buy-shares"
                type="button"
                id="buyShares"
                noButtonMargin
                onClick={() => redirectToBuyFlow(isGuestTypeUser)}
                variant="secondary"
                label="Buy Shares"
              />
            </span>
            <MFBeaconButton
              data-e2e="mail-check"
              type="button"
              id="mailCheck"
              noButtonMargin
              onClick={() => openMailACheckSlip(remittanceFormURL)}
              variant="secondary"
              label="Mail Check"
            />
          </div>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const AddTrustedContactSection = () => {
  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3 className="confirmation-section-headers">
            Add a Trusted Contact
          </h3>
          <p>
            A Trusted Contact is a resource for T. Rowe Price to contact on your
            behalf. If necessary, to help protect your accounts from financial
            exploitation, or to confirm your contact information if we are
            unable to reach you. You can update your trusted contacts and
            preferences in your profile settings.
          </p>
          <MFBeaconButton
            data-e2e="trusted-contact"
            type="button"
            id="trustedContact"
            onClick={navigateToTrustedContact}
            variant="secondary"
            label="Add a Trusted Contact"
          />
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const GotoMyAccountSection = ({ isGuestTypeUser }) => {
  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3 className="confirmation-section-headers">
            Log into your account
          </h3>
          <p>
            It&apos;s fast and easy to manage your account online, You can set
            up recurring contributions, add another bank account, add or update
            beneficiaries, make a one time contribution, and more.
          </p>
          <MFBeaconButton
            data-e2e="confirm-screen-acc-access"
            type="button"
            id="confirmScreenToAccAccess"
            onClick={() => redirectToAccountAccess(isGuestTypeUser)}
            variant="secondary"
            label="Go to My Account"
          />
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

const FundLaterConfirmationScreen = ({ appState }) => {
  const {
    store: { amount, loadedData, accountType, chosenInvestments }
  } = appState;

  const { remittanceFormURL } = loadedData;

  const authState = useAuthState();
  const isGuestTypeUser = !authState?.entitlements?.includes(
    'TRP_RET_EXTERNAL_USER_ACCESS'
  );

  // [US375779] prevent the browser back button from allowing the user
  // to go back to ReviewConfirm and submit again
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function() {
      window.history.pushState(null, document.title, window.location.href);
    });
  });

  return (
    <ExternalAuthenticator>
      <div>
        <div className="confirmation-wrapper">
          <section className="account-ready-message">
            <ConfirmationHeading />
          </section>

          <FundLaterTransactionConfirmationDetails
            loadedData={loadedData}
            investments={chosenInvestments}
            amount={amount}
            accountType={accountType}
          />

          <h2 className="next-steps">Next Steps</h2>

          <BuySharesSection
            remittanceFormURL={remittanceFormURL}
            isGuestTypeUser={isGuestTypeUser}
          />

          <AddTrustedContactSection />

          <GotoMyAccountSection isGuestTypeUser={isGuestTypeUser} />
        </div>
        <PhoneNumber />
        <style jsx>{styles}</style>
      </div>
    </ExternalAuthenticator>
  );
};

export default FundLaterConfirmationScreen;
